<ng-container *ngIf="vm$ | async as vm">
  <div class="l_flex m-l_flex">
    <div
      *ngFor="
        let facet of vm.displayFacets;
        trackBy: trackById;
        let last = last
      "
      data-dgat="facetFilter-c6f"
    >
      <ng-container *ngIf="!!filterItems[facet.id]">
        <button
          *ngIf="!!filterItems[facet.id]"
          #filterToggle
          [dgxPopoverTrigger]="filterPopover"
          [attr.id]="facet.id + '-button'"
          data-dgat="search-filter-575"
          type="button"
          df-button
          dfButtonType="passive"
          class="collection-filter-btn btn guts-p-h-1"
          [class.guts-m-r-1]="!last"
          [ngClass]="{
            'collection-filter-btn--selected': !!filterItems[facet.id].length
          }"
        >
          <span
            [ngClass]="{
              'collection-filter-btn--label': !filterItems[facet.id].length,
              'collection-filter-btn--selected--label':
                !!filterItems[facet.id].length
            }"
          >
            {{ getFacetLabel(facet) }}
          </span>

          <span
            class="num-selected-filters guts-p-l-half"
            *ngIf="filterItems[facet.id].length > 0"
            >{{ filterItems[facet.id].length }}</span
          >
          <df-icon
            [ngClass]="{
              'collection-filter-btn--icon-': !filterItems[facet.id].length,
              'collection-filter-btn--icon--selected':
                !!filterItems[facet.id].length
            }"
            icon="chevron-down"
            size="small"
            class="guts-p-l-quart guts-m-l-half"
          ></df-icon>
        </button>

        <dgx-popover
          #filterPopover
          [popoverArrowHidden]="true"
          placement="bottom-left"
        >
          <div class="overflow-scroll-gradient">
            <div
              class="
                facet-filter-container
                guts-p-h-1-half guts-p-b-2
                rel
                l_flex
                grid--direction-column
              "
            >
              <div>
                <div
                  class="
                    par--small
                    font-semibold
                    guts-p-h-half guts-p-b-half guts-p-t-1-half
                  "
                >
                  {{ getHeading(facet) }}
                </div>
                <dgx-data-search
                  *ngIf="showSearch(facet)"
                  [minLength]="1"
                  [placeholder]="i18n.Core_Search"
                  type="short"
                  (doSearch)="search(facet.id, $event)"
                  [isDisabled]="vm.status.filterUpdating"
                  [searchTerm]="searchTerms[facet.id]"
                ></dgx-data-search>
              </div>
              <div class="l_flex l_flex-center">
                <span
                  *ngIf="searchTerms[facet.id] && !facet.values.length"
                  class="text-center par--small par--light_a"
                  >{{ i18n.dgAssignmentsOverview_AssignmentEmptyTitle }}</span
                >
              </div>

              <button
                *ngFor="
                  let filterItem of facet.values.slice(
                    0,
                    numFacetsBeforeShowSearch
                  )
                "
                class="
                  listbox--option
                  filter-hover
                  guts-p-h-1
                  l_flex l_flex-middle
                  cursor-pointer
                "
                [attr.aria-selected]="
                  filterItems[facet.id].includes(filterItem.name)
                "
                (click)="filterToggled($event, facet, filterItem)"
                [attr.aria-pressed]="
                  filterItems[facet.id].includes(filterItem.name)
                "
                [id]="'facetFilterItem' + filterItem.name"
                [disabled]="vm.status.filterUpdating"
                data-dgat="facet-filters-a2c"
              >
                <input
                  type="checkbox"
                  tabindex="-1"
                  readonly="readonly"
                  class="guts-m-r-1"
                  [checked]="filterItems[facet.id].includes(filterItem.id)"
                  data-dgat="facet-filters-9f9"
                />
                <label class="cursor-pointer font-medium">
                  {{ filterItem.name }}
                </label>
              </button>
            </div>
          </div>
          <div class="divider guts-m-h-1-half"></div>
          <div
            class="
              l_flex
              grid--direction-column
              l_flex-justify-right l_flex-middle
              guts-p-full-1-half
            "
          >
            <button
              df-button
              dfButtonType="primary"
              (click)="closePopover(facet.id)"
              class="guts-m-b-1-quart full-width"
              data-dgat="facet-filters-7a0"
              [disabled]="vm.status.filterUpdating"
            >
              {{ i18n.Core_ShowResults }}
            </button>

            <button
              class="
                color-blue
                par--small
                font-medium
                uhover
                guts-m-r-1-half
                full-width
              "
              (click)="resetFilter(facet.id)"
              [attr.aria-label]="i18n.LearningSearch_ClearFilters"
              [disabled]="vm.status.filterUpdating"
              data-dgat="facet-filters-7dc"
            >
              {{ vm.clearButtonsCopy[facet.id] }}
            </button>
          </div>
        </dgx-popover>
      </ng-container>
    </div>
  </div>
</ng-container>
